import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./NotFound.module.css";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import ModalColumn from "../ModalColumn/ModalColumn";
import { RotatingAllenKey } from "../RotatingAllenKey/RotatingAllenKey";

type NotFoundProps = {
  title: string;
  message: string;
};

export const NotFound = ({ title, message }: NotFoundProps) => {
  return (
    <FixaModalBody>
      <ModalColumn gap="medium">
        <RotatingAllenKey />
        <div className={styles["textWrapper"]}>
          <FixaText textStyle="Heading.L">{title}</FixaText>
          <FixaText textStyle="Body.L">{message}</FixaText>
        </div>
      </ModalColumn>
    </FixaModalBody>
  );
};
